import React from 'react';

type Options = {
  delay?: number;
  validate?: (value: any) => string | undefined;
  defaultValue?: string | number;
};

const useTypingTimeout = (
  callback: (value: any) => void,
  options: Options | undefined = {}
) => {
  const { delay = 800, validate, defaultValue = '' } = options;
  const [error, setError] = React.useState<string | null>();
  const [input, setInput] = React.useState<string | number | number[] | null>(
    defaultValue
  );
  const inputValueRef = React.useRef<string | number | number[] | null>(
    defaultValue
  );
  const typingTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const onChange = (value: string | number | number[]) => {
    setInput(value);
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    const validationError = validate?.(value);
    setError(validationError);

    if (!validationError) {
      typingTimeoutRef.current = setTimeout(() => {
        callback(value);
      }, delay);
    }
  };

  React.useEffect(() => {
    if (defaultValue !== inputValueRef.current) {
      setInput(defaultValue);
      inputValueRef.current = defaultValue;
    }
  }, [defaultValue]);

  React.useEffect(() => {
    return () => {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    };
  }, []);

  return { onChange, error, input };
};

export default useTypingTimeout;
